/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {Col} from "react-bootstrap";
import {usePrimeCache} from "../../../Hooks/ServiceHooks";
import {service as RelationshipService} from "../../../Services/RelationshipService";
import {ContactDetails} from "./ContactDetails";


export const ContactCard = (props) => {

    usePrimeCache([RelationshipService]);

    const {
        contact,
        stakeholderId,
        relationshipId
    } = props;

    const relationshipTitle = RelationshipService.CachedTitleById(relationshipId);

    if (!relationshipTitle) {
        return null;
    }

    return <Col xs={12} className="sb-contact-list-node">
        <h2 className="sb-children-list-title">{relationshipTitle} Info:</h2>
        <ContactDetails contact={contact} stakeholderId={stakeholderId} />
    </Col>
}
